<template>
  <div>
    <div class="row pl-2 pr-2">
      <div class="col-12">        
        <div class="row">
          <div class="col-xl-5 col-12">
            <div class="form-group">
              <label>{{__("misc.searchByName")}}</label>
              <input type="text" class="form-control" v-model="filterName" />
            </div>
          </div>
          <div class="col-xl-5 col-12">
            <div class="form-group">
              <label>{{__("misc.typeCollaborators")}}</label>
              <select
                class="form-control"
                name="jpaFilter[sense_code_id][1]"
                v-model="filterTypeCollaborator"
              >
                <option
                  v-for="(typeCollaborator, code) in typeCollaborators"
                  :value="code"
                  v-bind:key="code"
                >
                  {{ typeCollaborator }}
                </option>
              </select>
            </div>
          </div>
          <div class="col-xl-2 col-12 mt-4">
            <button type="button" class="btn" @click="filter()">
              {{__("misc.filter")}}
            </button>
            <button type="button" class="btn"  @click="showGraph()" v-if="this.hideGraphToStart">
              {{__("misc.show")}} {{__("misc.graph")}}           
            </button>
          </div>
        </div>        
      </div>      
      <div class="col-12" id="div_bar_line_chart_pay_items_filters">        
        <bar-line-chart 
          :ref="this.stackedBarRef" 
          :url="initialUrl"
          :ext-chart-config=this.chart_options> </bar-line-chart>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      initialUrl: "",
      stackedBarRef: "",
      filterName: "",
      filterTypeCollaborator: null,
      hideGraphToStart: false,
      isGraphVisible: true,
      chart_options: {
        scales: {
          yAxes: [
            {
              type: "linear", // only linear but allow scale type registration. This allows extensions to exist solely for log scale for instance
              display: true,
              position: "left",
              id: "y-axis-1",
            },
            {
              type: "linear", // only linear but allow scale type registration. This allows extensions to exist solely for log scale for instance
              display: false,
              position: "right",
              id: "y-axis-2",
              gridLines: {
                drawOnChartArea: false,
              }
            }
          ]
        },
        responsive: true,
        maintainAspectRatio: false
      }
    };
  },
  mounted() {
    this.stackedBarRef = "bar-line-toogle" + this.refBar;
    this.initialUrl = this.url + "?" + "widgetId=" + this.widgetId;
        
    if (this.config != null){      
      var config = JSON.parse(this.config);      
      if (config.hideGraphToStart != null){
        this.hideGraphToStart = config.hideGraphToStart;
        if (this.hideGraphToStart){
          document.getElementById("div_bar_line_chart_pay_items_filters").style.visibility = "hidden";
          document.getElementById("div_bar_line_chart_pay_items_filters").style.height = "0px";
          this.isGraphVisible = false;
        }
      }
    }
  },
  methods: {
    filter() {
      var baseUrl = this.url + "?";

      baseUrl += "widgetId=" + this.widgetId + "&";

      if (this.filterName != null && this.filterName != ""){
        baseUrl += "filter[filterName]=" + this.filterName + "&";
      }

      if (this.filterTypeCollaborator != null && this.filterTypeCollaborator != ""){
        baseUrl += "filter[filterTypeCollaborator]=" + this.filterTypeCollaborator;
      } else {        
        baseUrl += "filter[filterTypeCollaborator]=" + Object.keys(this.typeCollaborators)[0];
      }
      
      this.$vs.loading();
      axios.get(baseUrl).then((response) => {                     
        this.$refs[this.stackedBarRef].drawBarLineGraph(response.data);      
        this.$vs.loading.close();  
      });
    },
    showGraph() {            
      if (this.isGraphVisible){
        document.getElementById("div_bar_line_chart_pay_items_filters").style.visibility = "hidden";
        document.getElementById("div_bar_line_chart_pay_items_filters").style.height = "0px";
        this.isGraphVisible = false;
      } else {
        document.getElementById("div_bar_line_chart_pay_items_filters").style.visibility = "visible";
        document.getElementById("div_bar_line_chart_pay_items_filters").style.height = "500px";
        this.isGraphVisible = true;
      }        
    }    
  },
  props: {
    refBar: {
      type: String,
      required: true,
    },
    url: {
      type: String,
      required: true,
    },
    typeCollaborators: {
      type: Object,
      required: true,
    },
    widgetId:{
      type: Number,
      required: true
    },
    config:{
      type: Object,
      required: false
    }
  },
};
</script>